const PLACEHOLDER = "unknown";

/**
 * Display name with the User create placeholder removed.
 * "Unknown Unknown" is empty. A real token next to a placeholder stays.
 */
export function usablePersonName(value?: string | null): string | undefined {
  const parts = (value ?? "")
    .split(/\s+/)
    .map((part) => part.trim())
    .filter((part) => part && part.toLowerCase() !== PLACEHOLDER);
  return parts.length ? parts.join(" ") : undefined;
}
